import React from 'react';
import './App.css';
import fish1 from './pic/fish/IMG_5227.JPG';
import fish2 from './pic/fish/IMG_5228.JPG';
import fish3 from './pic/fish/IMG_5229.JPG';
import fish4 from './pic/fish/IMG_5231.JPG';
import frozen1 from './pic/frozen/IMG_5104.JPG';
import frozen2 from './pic/frozen/IMG_5106.JPG';
import frozen3 from './pic/frozen/IMG_5107.JPG';
import frozen4 from './pic/frozen/IMG_5232.JPG';
import other1 from './pic/else/IMG_5099.JPG';
import other2 from './pic/else/IMG_5100.JPG';
import other3 from './pic/else/IMG_5101.JPG';
import other4 from './pic/else/IMG_5102.JPG';

export default function App() {
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [selectedCategory, setSelectedCategory] = React.useState('fish');
  const galleryRef = React.useRef(null);

  const imageSets = {
    fish: [fish1, fish2, fish3, fish4],
    frozen: [frozen1, frozen2, frozen3, frozen4],
    other: [other1, other2, other3, other4]
  };

  const handleMenuClick = (key) => {
    setSelectedCategory(key);
    setMenuOpen(false);
    requestAnimationFrame(() => {
      galleryRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };
  
  
  

  const styles = {
    page: {
      minHeight: '100vh',
      background: 'linear-gradient(to bottom, #dbeafe, #93c5fd)',
      color: '#1f2937',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '24px',
      boxSizing: 'border-box'
    },
    topBar: {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-start',
      alignSelf: 'stretch',
      padding: '0 16px'
    },
    menuWrapper: {
      position: 'relative'
    },
    menuButton: {
      background: '#1e3a8a',
      color: '#ffffff',
      border: 'none',
      borderRadius: '12px',
      padding: '10px 12px',
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      boxShadow: '0 8px 18px rgba(0,0,0,0.12)'
    },
    menuLine: {
      width: '22px',
      height: '2px',
      background: '#ffffff',
      borderRadius: '2px'
    },
    menuDropdown: {
      position: 'absolute',
      top: '52px',
      right: 0,
      background: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 10px 24px rgba(0,0,0,0.12)',
      padding: '12px 0',
      minWidth: '180px',
      zIndex: 10
    },
    menuItem: {
      padding: '10px 16px',
      textAlign: 'right',
      fontWeight: 700,
      color: '#1f2937',
      textDecoration: 'none',
      display: 'block'
    },
    menuItemHover: {
      backgroundColor: '#f3f4f6'
    },
    header: {
      textAlign: 'center',
      marginBottom: '32px'
    },
    title: {
      fontSize: '2.25rem',
      fontWeight: 800,
      color: '#1e3a8a',
      margin: '0 0 8px 0'
    },
    subtitle: {
      fontSize: '1.25rem',
      fontWeight: 600,
      margin: 0
    },
    card: {
      backgroundColor: '#ffffff',
      boxShadow: '0 10px 25px rgba(0,0,0,0.08)',
      borderRadius: '16px',
      padding: '24px',
      width: '100%',
      maxWidth: '768px',
      marginBottom: '24px',
      textAlign: 'right',
      boxSizing: 'border-box'
    },
    cardBlue: {
      backgroundColor: '#eff6ff',
      boxShadow: '0 6px 18px rgba(0,0,0,0.06)',
      borderRadius: '16px',
      padding: '24px',
      width: '100%',
      maxWidth: '768px',
      marginBottom: '24px',
      textAlign: 'center',
      boxSizing: 'border-box'
    },
    actionsRow: {
      display: 'flex',
      gap: '12px',
      justifyContent: 'center',
      marginTop: '12px',
      flexWrap: 'wrap'
    },
    actionBtn: {
      display: 'inline-block',
      padding: '10px 16px',
      borderRadius: '10px',
      color: '#ffffff',
      textDecoration: 'none',
      fontWeight: 700,
      boxShadow: '0 6px 16px rgba(0,0,0,0.12)'
    },
    actionBtnWhatsapp: { backgroundColor: '#25D366' },
    actionBtnCall: { backgroundColor: '#1d4ed8' },
    cardTitle: {
      fontSize: '1.5rem',
      fontWeight: 800,
      color: '#1e40af',
      margin: '0 0 12px 0'
    },
    list: {
      paddingRight: '24px',
      margin: 0,
      listStyle: 'disc',
      fontSize: '1.125rem'
    },
    listItem: {
      marginBottom: '8px'
    },
    mapSection: {
      width: '100%',
      maxWidth: '768px',
      marginBottom: '24px',
      textAlign: 'center',
      boxSizing: 'border-box'
    },
    mapButton: {
      display: 'block',
      backgroundColor: '#16a34a',
      color: '#ffffff',
      fontWeight: 700,
      padding: '12px 24px',
      borderRadius: '12px',
      textDecoration: 'none',
      boxShadow: '0 6px 16px rgba(0,0,0,0.15)',
      transition: 'transform 0.1s ease-in-out, box-shadow 0.2s ease-in-out'
    },
    mapButtonHover: {
      transform: 'translateY(-1px)',
      boxShadow: '0 10px 22px rgba(0,0,0,0.18)'
    },
    footer: {
      textAlign: 'center',
      marginTop: 'auto',
      fontSize: '0.875rem',
      color: '#374151'
    },
    mapFrame: {
      width: '100%',
      height: '320px',
      border: 0,
      borderRadius: '12px',
      boxShadow: '0 8px 22px rgba(0,0,0,0.08)'
    },
    hoursList: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
      fontSize: '1rem'
    },
    hourRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '8px 0',
      borderBottom: '1px solid #e5e7eb'
    },
    gallerySection: {
      backgroundColor: '#0f172a',
      color: '#f8fafc',
      width: '100%',
      maxWidth: '900px',
      borderRadius: '16px',
      padding: '24px',
      boxSizing: 'border-box',
      boxShadow: '0 12px 28px rgba(0,0,0,0.18)',
      marginBottom: '24px'
    },
    galleryTitle: {
      margin: '0 0 12px 0',
      textAlign: 'right',
      fontSize: '1.4rem'
    },
    galleryGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '16px'
    },
    galleryFrame: {
      backgroundColor: '#111827',
      borderRadius: '12px',
      padding: '12px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '200px',
      boxShadow: '0 10px 22px rgba(0,0,0,0.25)'
    },
    galleryImg: {
      maxWidth: '100%',
      maxHeight: '100%',
      objectFit: 'contain',
      borderRadius: '8px'
    },
    galleryEmpty: {
      textAlign: 'center',
      color: '#cbd5e1'
    }
  };


  return (
    <div dir="rtl" style={styles.page} className="app-page">
      <div style={styles.topBar}>
        <div style={styles.menuWrapper}>
          <button
            aria-label="פתח תפריט"
            style={styles.menuButton}
            className="menu-button"
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span style={styles.menuLine} />
            <span style={styles.menuLine} />
            <span style={styles.menuLine} />
          </button>
          {menuOpen && (
            <nav style={styles.menuDropdown}>
              <button
                style={{ ...styles.menuItem, width: '100%', background: 'none', border: 'none', cursor: 'pointer' }}
                onClick={() => handleMenuClick('fish')}
              >
                הדגים שלנו
              </button>
              <button
                style={{ ...styles.menuItem, width: '100%', background: 'none', border: 'none', cursor: 'pointer' }}
                onClick={() => handleMenuClick('frozen')}
              >
                קפואים
              </button>
              <button
                style={{ ...styles.menuItem, width: '100%', background: 'none', border: 'none', cursor: 'pointer' }}
                onClick={() => handleMenuClick('other')}
              >
                אחר
              </button>
              
            </nav>
          )}
        </div>
      </div>

      <header style={styles.header}>
        <h1 style={styles.title}>מסיקה דגים טריים וקפואים</h1>
        <p style={styles.subtitle}>איכות ללא תחרות מאז 1970</p>
      </header>

      <section id="fish" style={styles.card} className="card-elevated">
        <h2 style={styles.cardTitle}>מה תמצאו אצלנו:</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}>כל סוגי הדגים – טריים, קפואים ומעושנים</li>
          <li style={styles.listItem}>זיתים בעיבוד עצמי</li>
          <li style={styles.listItem}>סלטים ודליקטסים באיכות גבוהה</li>
          <li style={styles.listItem}>
            <span className="badge-free-shipping">משלוחים חינם!</span>
          </li>
        </ul>
      </section>
      <section style={styles.cardBlue} className="card-highlight">
        <h2 style={{...styles.cardTitle, textAlign: 'center'}}>הזמנות אצל חיים מסיקה</h2>
        <p style={{ fontSize: '1.125rem', margin: '0 0 8px 0' }}>אפשר גם בוואטסאפ!</p>
        <p className="highlight-phone" style={{ fontSize: '1.25rem', fontWeight: 800, margin: 0 }}>
          טלפון:
          {' '}
          <a href="tel:0528862896" style={{ color: '#1e40af', textDecoration: 'none' }}>052-8862896</a>
        </p>

      </section>
      <section id="frozen" style={styles.cardBlue} className="card-highlight">
        <h2 style={styles.cardTitle}>מבחר קפואים</h2>
        <p style={{ fontSize: '1.05rem', margin: '0 0 12px 0' }}>
          פילה סלמון, דניס, מושט, אמנון, טונה, לברק ועוד – ארוזים בוואקום
          ושומרים על טריות מיטבית.
        </p>
        <p style={{ fontSize: '1.05rem', margin: 0 }}>אפשר להזמין גם במארזי משפחה.</p>
      </section>

      <section ref={galleryRef} style={styles.gallerySection} id="gallery" className="gallery-section">
        <h3 style={styles.galleryTitle}>
          גלריה: {selectedCategory === 'fish' ? 'הדגים שלנו' : selectedCategory === 'frozen' ? 'קפואים' : selectedCategory === 'other' ? 'אחר' : 'יצירת קשר'}
        </h3>
        {imageSets[selectedCategory]?.length ? (
          <div style={styles.galleryGrid} className="gallery-grid">
            {imageSets[selectedCategory].map((src, idx) => (
              <div
                key={`${selectedCategory}-${idx}`}
                style={styles.galleryFrame}
                className="gallery-frame"
              >
                <img
                  src={src}
                  alt={`${selectedCategory}-${idx}`}
                  style={styles.galleryImg}
                  className="gallery-img"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        ) : (
          <div style={styles.galleryEmpty}>אין תמונות להצגה</div>
        )}
      </section>

      <section style={styles.cardBlue} className="card-highlight">
        <h2 style={{...styles.cardTitle, textAlign: 'center'}}>הזמנות אצל חיים מסיקה</h2>
        <p style={{ fontSize: '1.125rem', margin: '0 0 8px 0' }}>אפשר גם בוואטסאפ!</p>
        <p className="highlight-phone" style={{ fontSize: '1.25rem', fontWeight: 800, margin: 0 }}>
          טלפון:
          {' '}
          <a href="tel:0528862896" style={{ color: '#1e40af', textDecoration: 'none' }}>052-8862896</a>
        </p>
        <div style={styles.actionsRow}>
          <a
            href="tel:0528862896"
            aria-label="התקשר עכשיו"
            style={{ ...styles.actionBtn, ...styles.actionBtnCall }}
            className="action-btn action-btn-call"
          >
            התקשר עכשיו
          </a>
          <a
            href="https://wa.me/972528862896?text=%D7%94%D7%99%D7%99%2C%20%D7%A8%D7%A6%D7%99%D7%AA%D7%99%20%D7%9C%D7%94%D7%96%D7%9E%D7%99%D7%9F%20%D7%93%D7%92%D7%99%D7%9D"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="שלח הודעת וואטסאפ"
            style={{ ...styles.actionBtn, ...styles.actionBtnWhatsapp }}
            className="action-btn action-btn-whatsapp"
          >
            וואטסאפ
          </a>
        </div>
      </section>

      <section style={styles.card} id="other" className="card-elevated">
        <h2 style={styles.cardTitle}>עוד אצלנו</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}>מארזי על האש וסשימי מוכנים</li>
          <li style={styles.listItem}>תבלינים, שמנים וממרחים שמתאימים לדגים</li>
          <li style={styles.listItem}>שירות ניקוי ואריזה במקום</li>
        </ul>
      </section>

      <section style={styles.card} className="card-elevated">
        <h2 style={styles.cardTitle}>שעות פעילות</h2>
        <ul style={styles.hoursList}>
          <li style={styles.hourRow}><span>ראשון</span><span>08:00 - 20:00</span></li>
          <li style={styles.hourRow}><span>שני</span><span>08:00 - 20:00</span></li>
          <li style={styles.hourRow}><span>שלישי</span><span>08:00 - 20:00</span></li>
          <li style={styles.hourRow}><span>רביעי</span><span>08:00 - 20:00</span></li>
          <li style={styles.hourRow}><span>חמישי</span><span>08:00 - 21:00</span></li>
          <li style={styles.hourRow}><span>שישי</span><span>08:00 - 15:00</span></li>
          <li style={{...styles.hourRow, borderBottom: 'none'}}><span>שבת</span><span>סגור</span></li>
        </ul>
      </section>

      <section style={styles.mapSection} id="contact">
        <iframe
          title="מפת מסיקה דגים"
          style={styles.mapFrame}
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          src="https://www.google.com/maps?q=%D7%A1%D7%95%D7%A7%D7%95%D7%9C%D7%95%D7%91+20+%D7%A4%D7%99%D7%A0%D7%AA+%D7%A8%D7%95%D7%A4%D7%99%D7%9F+1&output=embed"
        />
        <div style={{ marginTop: '10px' }}>
          <a
            href="https://www.google.com/maps?q=%D7%A1%D7%95%D7%A7%D7%95%D7%9C%D7%95%D7%91+20+%D7%A4%D7%99%D7%A0%D7%AA+%D7%A8%D7%95%D7%A4%D7%99%D7%9F+1"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#1e40af', textDecoration: 'none', fontWeight: 700 }}
            className="map-link"
          >
            פתח ב-Google Maps
          </a>
        </div>
      </section>

      <a
        href="https://wa.me/972528862896?text=%D7%94%D7%99%D7%99%2C%20%D7%A8%D7%A6%D7%99%D7%AA%D7%99%20%D7%9C%D7%94%D7%96%D7%9E%D7%99%D7%9F%20%D7%93%D7%92%D7%99%D7%9D"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="שלח הודעת וואטסאפ"
        className="floating-whatsapp"
      >
        הודעת וואטסאפ
      </a>

      <footer style={styles.footer}>
        <p>סוקולוב 20 פינת רופין 1</p>
        <p>© מסיקה דגים - כל הזכויות שמורות</p>
      </footer>
    </div>
  );
}
